/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type GameOfWeekWrongGameResponse = {
  message: Record<string, any>;
  code: GameOfWeekWrongGameResponse.code;
  data: string;
};
export namespace GameOfWeekWrongGameResponse {
  export enum code {
    ERROR_GAME_NOT_FOUND = 'error.game.not-found',
  }
}

